module.exports = __webpack_public_path__ + "1965b519f0e74975c4fa375eb77bc2fa.png";